<template>
  <div>
      <div class="single-ticket--row" v-if="showTotalOdd">
        <span>{{$t('totalOdd')}}:</span>
        <span class="value-field">{{format(ticket.TotalOdd)}}</span>
      </div>
      <div class="single-ticket--row" v-if="isStakeBTVisible()">
        <span>{{$t('stakeBt')}}:</span>
        <span class="value-field">{{format(ticket.StakeBT)}}</span>
      </div>
      <div class="single-ticket--row" v-if="isStakeBTVisible()">
        <span>{{$t('stakeAt')}}:</span>
        <span class="value-field">{{format(ticket.StakeAT)}}</span>
      </div>
      <div class="single-ticket--row" v-if="!isStakeBTVisible()">
        <span>{{$t('stake')}}:</span>
        <span class="value-field">{{format(ticket.StakeAT)}}</span>
      </div>
      <div class="single-ticket--row" v-if="isWinVisible() && isPossibleWinBTVisible()">
        <span>{{getPossibleWinBTText()}}:</span>
        <span class="value-field">{{getPossibleWinBTValue()}}</span>
      </div>
      <div class="single-ticket--row" v-if="isWinVisible() && isPossibleWinBTVisible()">
        <span>{{getPossibleWinATText()}}:</span>
        <span class="value-field">{{getPossibleWinATValue()}}</span>
      </div>
      <div class="single-ticket--row" v-if="isWinVisible() && !isPossibleWinBTVisible()">
        <span>{{getPossibleWin()}}:</span>
        <span class="value-field">{{getPossibleWinATValue()}}</span>
      </div>
      <div class="single-ticket--row" v-if="showTotalOdd && !this.isHistory">
        <span>{{$t('possibleWinBT')}}:</span>
        <span class="value-field">{{getPossibleWinValue(ticket, false)}}</span>
      </div>
      <div class="single-ticket--row" v-if="showTotalOdd && !this.isHistory">
        <span>{{$t('possibleWinAT')}}:</span>
        <span class="value-field">{{getPossibleWinValue(ticket)}}</span>
      </div>
  </div>
</template>

<script>
import NumberFormat from '@/mixins/NumberFormat'
import LanguageHelper from '@/mixins/LanguageHelper'

export default {
  mixins: [NumberFormat, LanguageHelper],
  props: {
    ticket: {
      type: Object,
      required: true
    },
    isHistory: {
      type: Boolean,
      default: false
    },
    hideWinning: {
      type: Boolean,
      default: false
    },
    showTotalOdd: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isWinVisible: function () {
      return !this.hideWinning && !this.ticket.isOpen
    },
    getPossibleWinBTText () {
      if (this.isHistory) {
        return this.$t('win_bt')
      } else {
        return this.$t('possibleWinBT')
      }
    },
    getPossibleWinATText () {
      if (this.isHistory) {
        return this.$t('win_at')
      } else {
        return this.$t('possibleWinAT')
      }
    },
    getPossibleWin () {
      if (this.isHistory) {
        return this.$t('win')
      } else {
        return this.$t('possibleWin')
      }
    },
    getPossibleWinBTValue () {
      return this.format(this.ticket.PossibleWinBT)
    },
    getPossibleWinATValue () {
      return this.format(this.ticket.PossibleWinAT)
    },
    isStakeBTVisible: function () {
      return this.ticket.StakeBT !== this.ticket.StakeAT
    },
    isPossibleWinBTVisible: function (tiket) {
      return this.ticket.PossibleWinBT !== this.ticket.PossibleWinAT
    },
    format: function (value) {
      return this.formatNumber(value, this.getLanguageCodeForNumbers(), 2)
    },
    getPossibleWinValue (ticket, isPossibleAT = true) {
      if (ticket.Status === 2) {
        if (isPossibleAT) {
          return this.format(ticket.PossibleWinAT)
        } else {
          return this.format(ticket.PossibleWinBT)
        }
      }
      return this.format(0.00)
    }
  }
}
</script>
